import React, { useEffect, useState } from "react";
import yellowalert from "src/assets/images/alert-icon-yellow.png";
import closeic from "src/assets/images/close-ic.png";
import DisplayLongDescriptionAndVariantMFRName from "../../../component/Product/DisplayLongDescriptionAndVariantMFRName";
import ClearSingleCartProductFromCart from "../../../component/Global/Cart/ClearSingleCartProductFromCart";
import QuantityPickerForUpdateCart from "../../../component/Global/Cart/QuantityPickerForUpdateCart";
import Common from "../Common";
import QuantityScheduler from "./QuantityScheduler";
import DisplayQtyMinQtyMult from "../../../component/Product/DisplayQtyMinQtyMult";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { Tooltip } from "src/component/Tooltip";
import liveAuth from "src/helper/liveAuth";
import System from "../../../helper/system";
import Helper from "src/support/Helper";
import FadeInOut from "../../../component/FadeInOut";
import CustomerPartNumberOptions from "../../../component/Global/Cart/CustomerPartNumberOptions";
import { InputWithDebounce } from "../../../component/InputWithDebounce";
import CartRepository from "src/repository/CartRepository";
import { isArray, isNumber } from "underscore";
import AxiosIndicatorRunTimeLoader from "../../../component/AxiosIndicatorRunTimeLoader";
import ProductLegends from "src/pages/ProductListing/ProductLegends";
import { useCartStore } from "src/hooks/cart";
import noImage from "src/assets/images/noimage.png";
import Constants from "src/support/Constants";
import useReduxState from "src/hooks/useReduxState";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import NavigateToPDP from "src/component/Global/Product/NavigateToPDP";
import FactoryLeadTimeDisplay from "src/component/Product/FactoryLeadTimeDisplay";

const CartList = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ CART_DATA_ERROR, CART_BEFORE_TO_SEND_SERVER, CART_DATA, CART_DATA_OBJECT, CART_LOADER_DATA_OBJECT, CART_PRODUCT_DATA, CART_PRODUCT_INVENTORY_DATA, CART_PRODUCT_PRICING_DATA }, { get_checkout_charge }, { SET_CART_DATA_ERROR }] = useCartStore();
  const [isDisplayCpnOption, setIsDisplayCpnOption] = useState(false);
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [isLoader, setIsLoader] = useState(true);
  const [isOpenedBackOrderPopup, setIsOpenedBackOrderPopup] = useState(false);
  const [isVendorExcluded, setIsVendorExcluded] = useReduxState(false, 'setIsVendorExcluded');
  const [, setCheckoutCharge] = useReduxState('', 'setCheckoutCharge');


  useEffect(() => {
    let errorCount = 0;

    Object.keys(CART_BEFORE_TO_SEND_SERVER).map((item) => {
      if (CART_BEFORE_TO_SEND_SERVER[item]?.obsolete_EOL_invalidate_message_active) {
        errorCount++;
      }
    });

    Object.keys(CART_DATA_OBJECT).map((item) => {
      if (CART_DATA_OBJECT[item]?.isProductAvailableFromMainAPI === false ||
        CART_DATA_OBJECT[item]?.isScheduleTotalQtyValid === false) {
        errorCount++;
      }
    });

    if (errorCount > 0) {
      SET_CART_DATA_ERROR(true);
    } else {
      SET_CART_DATA_ERROR(false);
    }

    if (firstServerCall) {
      setTimeout(() => {
        setIsDisplayCpnOption(true);
        setFirstServerCall(false);
      }, 2500);
    }
  }, [CART_DATA_OBJECT, CART_BEFORE_TO_SEND_SERVER]);

  useEffect(() => {
    const fetchCheckoutCharges = async () => {
      let res = await get_checkout_charge();
      setCheckoutCharge(res?.invoiceAmount || 0);
    };
    fetchCheckoutCharges();
  }, []);

  useEffect(() => {
    if (!firstServerCall && !__check(['VIEW_CART_API_CALL', 'CART_API_CALL']).status && isLoader) {
      if (currencyDifferenceDetected()) {
        setTimeout(() => {
          setIsLoader(false)
          Helper.monitorJSDx()
        }, 3500);
      } else {
        setIsLoader(false)
        Helper.monitorJSDx()
      }
    }
  }, [firstServerCall, __check(['VIEW_CART_API_CALL', 'CART_API_CALL']).status]);

  // useEffect(() => {
  //   openInventoryAlert()
  // }, [CART_DATA_OBJECT, CART_PRODUCT_DATA, CART_DATA, CART_PRODUCT_INVENTORY_DATA]);

  useEffect(() => {
    if (isVendorExcluded) {
      setIsVendorExcluded(false);
    }
    if (CART_DATA?.length > 0 &&
      CART_DATA.filter(x => x?.isVendorExcluded === true && x?.isEligibleShipping != false).length > 0) {
      setIsVendorExcluded(true);
    }
  }, [CART_DATA, CART_DATA_OBJECT])


  useEffect(() => {
    if (Object.entries(CART_DATA)?.length > 0 && Object.entries(CART_PRODUCT_DATA)?.length > 0 && Object.entries(CART_PRODUCT_INVENTORY_DATA)?.length > 0) {
      let backorderCnt = 0


      Object.entries(CART_DATA).map(obj => {
        const inventoryQas = CART_PRODUCT_INVENTORY_DATA[obj[1].partNumber]?.qas || 0;
        const checkQuantity = obj[1].quantity > inventoryQas;

        if (obj[1].isProductAvailableFromMainAPI && (CART_PRODUCT_DATA[obj[1].itemNumber]).ObsoleteFlag === false && checkQuantity && (obj[1].backOrderedQuantity === 0 || (obj[1].backOrderedQuantity !== (obj[1].quantity - inventoryQas)))) {
          backorderCnt++;
        }

      })

      if (backorderCnt > 0) {
        setIsOpenedBackOrderPopup(true)
        setTimeout(() => {
          System.popup('InventoryAlertPopup', { from: "onload" });
        }, 500);

      }
    }

    if (firstServerCall) {
      setFirstServerCall(false);
    }
  }, [CART_DATA_OBJECT, CART_PRODUCT_DATA, CART_DATA, CART_PRODUCT_INVENTORY_DATA])

  const getCartProductInventoryQuantityByERPPartNumber = (ERPPartNumber) => {
    return new Common().getCartProductInventoryQuantityByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
  };

  const getCartProductInventoryObjectByERPPartNumber = (ERPPartNumber) => {
    return new Common().getCartProductInventoryObjectByERPPartNumber(ERPPartNumber, CART_PRODUCT_INVENTORY_DATA);
  };

  const getCartProductPricingByERPPartNumber = (ERPPartNumber) => {
    return new Common().getCartProductPricingByERPPartNumber(ERPPartNumber, CART_PRODUCT_PRICING_DATA);
  };

  const authLoggedIn = () => {
    return liveAuth.check();
  };

  const validateInventoryDisplayMessageStatus = (single_product_here) => {
    return !!(single_product_here?.ERPPartNumber &&
      new Common().getInventoryOutOfStockFlagByERPPartNumber(CART_DATA_OBJECT, single_product_here.ERPPartNumber));
  };

  const renderRefPartNumberTooltip = () => {
    return "This is an optional field for your reference only. The value entered is for this order only and will not be saved for future orders.";
  };

  const checkIfObsoleteFlagOrEOLFlagExists = (ItemNumber) => {
    if (CART_BEFORE_TO_SEND_SERVER[ItemNumber]?.obsolete_EOL_invalidate_message_active) {
      SET_CART_DATA_ERROR(true);
    } else if (CART_DATA_ERROR === false && !CART_BEFORE_TO_SEND_SERVER[ItemNumber]?.obsolete_EOL_invalidate_message_active) {
      SET_CART_DATA_ERROR(false);
    }
  };

  const currencyDifferenceDetected = () => {
    return !!(CART_DATA && isArray(CART_DATA) && CART_DATA.length > 0 && CART_DATA[0]?.currency && CART_DATA[0].currency !== window.mct);
  };

  const isProductAvailableFromMainAPIMessage = "You can no longer purchase this item on our site. Remove this item to proceed to Checkout."
  const isEligibleShippingMessage = "Part is not eligible to ship to country selected. Remove this item to proceed to Checkout."
  const isVendorExcludedMessage = "Part is not eligible. Remove this item to proceed to Checkout"


  //By Ramya Kannan [View cart - Adobe script ]
  const [isCartViewEvent, setCartViewEvent] = useState(true);
  useEffect(() => {
    if (isArray(CART_DATA) && isCartViewEvent) {
      viewCartEvent();
      setCartViewEvent(false)
    }
  }, [CART_DATA])

  function viewCartEvent() {
    localStorage.setItem("adobeEventType", "cartViewEvent");
    let prodDetails = CART_DATA;
    let cartDetails = {
      "additionSource": "PLP",
      "cartType": "checkout"
    }
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
    }
  }

  return (
    <>
      {(__check(['VIEW_CART_API_CALL', 'CART_API_CALL']).render && isLoader) ? <AxiosIndicatorRunTimeLoader /> :
        <>
          {!(CART_DATA && Object.entries(CART_DATA).length > 0 && CART_DATA.length > 0) ? (
            <>
              <FadeInOut show={true} duration={1000} className="cleared-cart-wrapper">
                <div className="center-link">
                  <a href={System.getHomepageUrl()} className="bs5 btn btn-primary w240">
                    Continue Shopping  </a>
                </div>
              </FadeInOut>
            </>
          ) :
            <div className="bs5 row">
              <div className="col-12">
                <div className="cart-list-table table-responsive">
                  <table className="table" style={{ visibility: currencyDifferenceDetected() ? "hidden" : "visible", }} >
                    <tbody>
                      {CART_DATA && Object.entries(CART_DATA).length > 0 && CART_DATA.length > 0 &&
                        CART_DATA.map((v, i) => {
                          let validateSingleProduct = v.isProductAvailableFromMainAPI === false || v.isEligibleShipping === false || v.isVendorExcluded === true
                          let isUpdatingCpnType = [];

                          if (!validateSingleProduct) {
                            isUpdatingCpnType[v.ItemNumber] = !!(CART_LOADER_DATA_OBJECT && CART_LOADER_DATA_OBJECT[v.ItemNumber]?.isUpdatingCpnType && __check(["VIEW_CART_API_CALL"]).status);
                            checkIfObsoleteFlagOrEOLFlagExists(v.ItemNumber);
                          }

                          return (
                            <React.Fragment key={v.ItemNumber}>
                              <>
                                <tr key={v.ItemNumber} className={validateSingleProduct ? "" : CART_PRODUCT_DATA[v.ERPPartNumber] && CART_PRODUCT_DATA[v.ERPPartNumber].NCNRFlag ? "ncnr" : "non-ncnr"}>
                                  <td className="cart-list-product-img">
                                    <div className="product-info nopadding">
                                      <span>Item: {i + 1}</span>
                                      {CART_DATA_OBJECT[v.ERPPartNumber] && (
                                        <div className="product-img sect-1 text-center">
                                          <img alt="Product" src={CART_DATA_OBJECT[v.ERPPartNumber].assetURL ? CART_DATA_OBJECT[v.ERPPartNumber].assetURL : noImage} />
                                        </div>)}
                                      {!validateSingleProduct && (
                                        <div className="prod-option-icon sect-2 d-flex flex-wrap">
                                          <ProductLegends single_product={CART_PRODUCT_DATA[v.ERPPartNumber]}
                                            onlyIcon={true} />
                                        </div>)}
                                    </div>
                                  </td>

                                  <td className="cart-list-product-detail">
                                    <div className="d-flex">
                                      <div className="product-detail mb-3 pb-1">
                                        <div className={CART_DATA_OBJECT[v.ERPPartNumber]?.isProductAvailableFromMainAPI === false ? "product-name text-black" : "product-name"}>
                                          <div className="d-flex align-items-center">
                                            {CART_DATA_OBJECT[v.ERPPartNumber] && (
                                              <NavigateToPDP data={{
                                                ManufacturerName: v?.manufacturerName,
                                                ERPMFRPartNumber: CART_DATA_OBJECT[v?.ERPPartNumber]?.ERPMFRPartNumber,
                                                ItemNumber: v?.ItemNumber,
                                              }} class='cursor-pointer text-wrap text-break'>
                                                <div className={CART_DATA_OBJECT[v.ERPPartNumber]?.isProductAvailableFromMainAPI ? "text-blue font-12" : "font-12"}>
                                                  <strong>
                                                    {CART_DATA_OBJECT[v.ERPPartNumber].ERPMFRPartNumber}
                                                  </strong>
                                                </div>
                                              </NavigateToPDP>
                                            )}

                                          </div>
                                          <div className="font-12">
                                            <DisplayLongDescriptionAndVariantMFRName
                                              currentProduct={CART_PRODUCT_DATA[v.ERPPartNumber]}
                                              no_show_more={true}
                                            />
                                          </div>
                                        </div>
                                        <div className="text-darkgreen">
                                          <span className="d-flex text-darkgreen w-100 align-items-center font-12 mb-0">
                                            <b>In Stock: </b>
                                            <b className="me-1">{getCartProductInventoryQuantityByERPPartNumber(v.ERPPartNumber)}</b>
                                            <Tooltip opener={() => <i className="fa fa-check-circle me-1" />} content={() => renderTooltip()} />
                                          </span>
                                        </div>
                                        {!validateSingleProduct && (
                                          <FactoryLeadTimeDisplay single_product={CART_PRODUCT_DATA[v.ERPPartNumber]}
                                            single_product_inventory={getCartProductInventoryObjectByERPPartNumber(v.ERPPartNumber)} />)}
                                      </div>
                                      {!validateSingleProduct && (isUpdatingCpnType[v.ItemNumber] ? (
                                        <div className="price-table-list ms-auto">
                                          <AxiosIndicatorRunTimeLoader />
                                        </div>
                                      ) : (
                                        <>
                                          <div className="price-table-list ms-auto">
                                            {(v.priceSource && v.priceSource.replace(/\s+/g, '').toUpperCase() === 'CUSTOMERPRICE') &&
                                              <div className="blue-head cpn-box">
                                                <span className="text-nowrap">Customer Specific Pricing</span>
                                                <span className="fa fa-handshake-o" />
                                              </div>
                                            }
                                            <div className="bs5 row">
                                              <div className="col-6">
                                                <span>Unit Price:</span>
                                              </div>
                                              <div className="col-6 text-end font_bold_currency">
                                                <span>
                                                  {Helper.getFormatNumber(Number(v.unitPrice), window.mct, window.mcs, 5)}
                                                </span>
                                              </div>
                                            </div>
                                            <div className="bs5 row">
                                              <div className="col-6">
                                                <span>Subtotal:</span>
                                              </div>
                                              <div className="col-6 text-end font_bold_currency">
                                                <span>
                                                  {isNumber(v.subtotal)
                                                    ? Helper.getFormatNumber(Number(v.subtotal), window.mct, window.mcs)
                                                    : ""}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ))}
                                    </div>
                                    {!validateSingleProduct && (
                                      <div className="d-flex justify-content-start part-info">
                                        {CART_PRODUCT_DATA[v.ERPPartNumber] && isDisplayCpnOption && (
                                          <CustomerPartNumberOptions
                                            single_product_inventory={getCartProductInventoryObjectByERPPartNumber(v.ERPPartNumber)}
                                            single_product={CART_PRODUCT_DATA[v.ERPPartNumber]}
                                            single_product_pricing_list={getCartProductPricingByERPPartNumber(v.ERPPartNumber)}
                                            updationCompletedCallback={async (SELECTED_CUSTOMER_PART_NUMBER, SELECTED_TYPE) => {
                                              let CPNValue = SELECTED_TYPE === Constants.cpnTypes.CPN ? v.cpn : v.manualCPN
                                              if (CPNValue !== SELECTED_CUSTOMER_PART_NUMBER || v.cpnTypeName !== SELECTED_TYPE) {
                                                let param = {
                                                  cartDetailId: v.cartDetailId,
                                                  cpnType: SELECTED_TYPE,
                                                }
                                                if (SELECTED_TYPE === Constants.cpnTypes.CPN) {
                                                  param.cpn = SELECTED_CUSTOMER_PART_NUMBER
                                                } else {
                                                  param.manualCPN = SELECTED_CUSTOMER_PART_NUMBER
                                                }
                                                await new CartRepository().updateToCartServer(param);
                                              }
                                            }}
                                            displayManualCpn={true}
                                            defaultValue={v.cpn}
                                            single_cpn_data={v}
                                          />
                                        )}
                                        <div className="form-group">
                                          <label htmlFor="sel1">
                                            <b>Line Note</b>
                                            <Tooltip position={"right"} content={() => renderRefPartNumberTooltip()}
                                              opener={() => (
                                                <i className="fa fa-info-circle ms-1 font-13" />
                                              )} />
                                          </label>
                                          <div>
                                            <InputWithDebounce
                                              className="form-control"
                                              type="text"
                                              placeholder="Enter note here"
                                              defaultValue={v.referencePartNumber}
                                              onChange={async (value) => {
                                                await new CartRepository().updateReferencePartNumberByCartDetailID(
                                                  v.cartDetailId,
                                                  value
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>
                                      </div>)}
                                  </td>

                                  {validateSingleProduct && (
                                    <td className="cart-list-product-update">
                                      <ClearSingleCartProductFromCart currentCartItem={v}>
                                        <button className="bs5 btn btn-secondary btn-sm ms-auto">
                                          Remove item from cart
                                        </button>
                                      </ClearSingleCartProductFromCart>
                                    </td>)}

                                  {!validateSingleProduct && (
                                    <td className="cart-list-product-update">
                                      <FadeInOut show={true} duration={250} >
                                        <div className="quantity clearfix">
                                          <QuantityPickerForUpdateCart
                                            cart_current_list_index={i}
                                            show_validation_message_based_in_input_quantity_Insufficient_Inventory={true}
                                            single_product_inventory={getCartProductInventoryObjectByERPPartNumber(v.ERPPartNumber)}
                                            single_product={CART_PRODUCT_DATA[v.ItemNumber]}
                                            single_cart_data={v}
                                            single_product_pricing_list={getCartProductPricingByERPPartNumber(v.ERPPartNumber)}
                                          />
                                        </div>
                                      </FadeInOut>
                                      <div className="p-15">
                                        <div className="text-start small-text light light-text collapse_minmax">
                                          <DisplayQtyMinQtyMult
                                            single_product={CART_PRODUCT_DATA[v.ERPPartNumber]}
                                          />
                                        </div>
                                        {v.ERPPartNumber && validateInventoryDisplayMessageStatus(CART_PRODUCT_DATA[v.ERPPartNumber]) && !(CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag) && (
                                          <>
                                            <a href={void 0} onClick={() => {
                                              System.popup("InventoryAlertPopup", {
                                                CURRENT_CART_DATA_SINGLE: v,
                                              });
                                            }} >Backorder Remaining Quantity</a>
                                            <br />
                                          </>
                                        )}
                                        {authLoggedIn() ? (
                                          <QuantityScheduler
                                            CART_DATA_SINGLE={v}
                                            single_product_inventory={getCartProductInventoryObjectByERPPartNumber(v.ERPPartNumber)}
                                            CART_PRODUCT_DATA={CART_PRODUCT_DATA[v.ERPPartNumber]}
                                          />
                                        ) : ("")}
                                      </div>
                                      {(v.backOrderedQuantity && v.backOrderedQuantity > 0 &&
                                        getCartProductInventoryQuantityByERPPartNumber(v.ERPPartNumber) > 0) ?
                                        (
                                          <div className="bs5 row">
                                            <div className="col-6">Available:</div>
                                            <div className="col-6 text-end">
                                              {getCartProductInventoryQuantityByERPPartNumber(v.ERPPartNumber)}
                                            </div>
                                          </div>
                                        ) : null}
                                      {v.backOrderedQuantity !== undefined && v.backOrderedQuantity > 0 && (
                                        <div className="bs5 row">
                                          <div className="col-6">Backordered:</div>
                                          <div className="col-6 text-end">{v.backOrderedQuantity}</div>
                                        </div>
                                      )}
                                    </td>)}

                                  <td className="cart-list-close">
                                    {validateSingleProduct && (<div className="alert alert-danger not-eligible-alert">
                                      <div className="bs5 w-100 d-flex justify-content-center">
                                        {v.isProductAvailableFromMainAPI === false && (<span>{isProductAvailableFromMainAPIMessage}</span>)}
                                        {v.isEligibleShipping === false && (<span>{isEligibleShippingMessage}</span>)}
                                        {v.isVendorExcluded && (<span>{isVendorExcludedMessage}</span>)}
                                        <img className="ms-2" alt="Alert" src={yellowalert} />
                                      </div>
                                    </div>)}
                                    <ClearSingleCartProductFromCart currentCartItem={v}>
                                      <div className="close-ic">
                                        <img src={closeic} alt="Close" />
                                      </div>
                                    </ClearSingleCartProductFromCart>
                                  </td>
                                </tr>

                                {!validateSingleProduct && (
                                  <tr>
                                    <td className="cart-list-error"></td>
                                    <td colSpan={3} className="cart-list-error">
                                      {(CART_PRODUCT_DATA[v.ERPPartNumber] && CART_PRODUCT_DATA[v.ERPPartNumber].NCNRFlag === true) && (
                                        <div className="alert alert-dark ncnr-alert">
                                          <b>NCNR:</b> <span>Non-Cancelable/Non-Returnable</span>
                                        </div>
                                      )}
                                      {(CART_BEFORE_TO_SEND_SERVER[v.ItemNumber]?.obsolete_EOL_invalidate_message_active !== undefined &&
                                        CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].obsolete_EOL_invalidate_message_active === true) && (
                                          <>
                                            {(CART_PRODUCT_DATA[v.ERPPartNumber] && CART_PRODUCT_DATA[v.ERPPartNumber].ObsoleteFlag === true) && (
                                              <div className="alert alert-danger not-eligible-alert">
                                                <div className="bs5 w-100 d-flex justify-content-center">
                                                  <span>
                                                    This part has insufficient stock and not eligible for backorder. Please edit quantity to proceed to Checkout.
                                                  </span>
                                                  <img className="ms-2" alt="Alert" src={yellowalert} />
                                                </div>
                                              </div>
                                            )}
                                            {(CART_PRODUCT_DATA[v.ERPPartNumber] && CART_PRODUCT_DATA[v.ERPPartNumber].EndOfLifeOFlag === true) && (
                                              <div className="alert alert-danger not-eligible-alert">
                                                <div className="bs5 w-100 d-flex justify-content-center">
                                                  <span>
                                                    This part has insufficient stock and not eligible for backorder. Please edit quantity to proceed to Checkout.
                                                  </span>
                                                  <img className="ms-2" alt="Alert" src={yellowalert} />
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        )}

                                      {(CART_DATA_OBJECT[v.ERPPartNumber] && !CART_DATA_OBJECT[v.ERPPartNumber].isScheduleTotalQtyValid) && (
                                        <div className="alert alert-danger not-eligible-alert">
                                          <div className="bs5 w-100 d-flex justify-content-center">
                                            <span>
                                              You cannot schedule more than the order quantity selected.
                                            </span>
                                            <img className="ms-2" alt="Alert" src={yellowalert} />
                                          </div>
                                        </div>
                                      )}
                                    </td>
                                  </tr>)}
                              </>
                            </React.Fragment>
                          )
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </>
      }
    </>
  );
};

export default CartList;